import axios from 'axios';
import {
  PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_BEGIN,
  PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_SUCCESS,
  PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_FAILURE,
  PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { processAndReturnNewForm } from '../../../common/projectOnBoardUtil';

export function fetchPluginForm(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_BEGIN,
    });
    const { projectId, version, code } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/extensions/${code}/code/loadFields`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_SUCCESS,
            data: res.data ? res.data : '',
            pluginCode: code,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchPluginFormError() {
  return {
    type: PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_BEGIN:
      return {
        ...state,
        fetchPluginFormPending: true,
        fetchPluginFormError: null,
      };

    case PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_SUCCESS:
      const popularPluginForm = processAndReturnNewForm(
        state.popularPluginForm,
        action.data,
        action.pluginCode,
      );
      console.log('popularPluginForm :>> ', popularPluginForm);
      return {
        ...state,
        fetchPluginFormPending: false,
        fetchPluginFormError: null,
        popularPluginForm,
      };

    case PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_FAILURE:
      return {
        ...state,
        fetchPluginFormPending: false,
        fetchPluginFormError: action.data.error,
      };

    case PROJECT_ON_BOARD_FETCH_PLUGIN_FORM_DISMISS_ERROR:
      return {
        ...state,
        fetchPluginFormError: null,
      };

    default:
      return state;
  }
}
